import { Component, ViewEncapsulation, Inject, ChangeDetectorRef, SimpleChanges, ViewChild, ElementRef, PLATFORM_ID, HostBinding } from '@angular/core';
import { ComponentModalBase } from '@framework/base/component';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormArray, UntypedFormControl, FormArray, FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '@app/env/environment';
import { debounceTime } from 'rxjs/operators';
import { RssFeedHttpService } from '@modules/company/services/rss-feed.http-service';
import { UserProfileViewModel, UserViewModel } from '@modules/user/store/models';
import { CampaignViewModel, CompanyViewModel } from '@modules/company/models/store-view-models';
import { StoryOutputApiModel } from '@modules/story/models/api-models/output';
import { CoreState } from '@app/store/core/states';
import { ScrollbarComponent } from '@framework/components';
import { PaginationModel } from '@framework/models/pagination-models';
import { ModalService, ToastService } from '@framework/services';
import { UtilityHelper } from '@framework/utilities';
import { emailCustomizeSettingAction, storyActions } from '@modules/company-admin/store/actions';
import { campaignActions } from '@modules/company/store/actions';
import { GetCampaignInputApiModel } from '@modules/company/models/api-models/input';
import { companySelectors, campaignSelectors } from '@modules/company/store/selectors';
import { RequestInputApiModel } from '@modules/shared/models/api-models/input';
import { CommentHttpService } from '@modules/shared/services';
import { RequestStoryStoreScope, RequestStoryStoreSnapshot } from '@modules/shared/services/request-story-store-scope.service';
import { storyAction, storyBuilderActions, storyStepActions } from '@modules/story/store/actions';
import { LoadUserInputApiModel } from '@modules/user/models/input';
import { ValidateUserOutApiModel } from '@modules/user/models/output';
import { userActions, userPermissionActions } from '@modules/user/store/actions';
import { userSelectors, userProfileSelectors } from '@modules/user/store/selectors';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { isString } from 'lodash';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { StoryHttpService } from '@modules/company-admin/store/services';
import { isPlatformBrowser } from '@angular/common';
import { RequestVideoRecorderMediaComponent } from '../../request-video-recorder-media';
import { StoryFlowMenuItemViewModel } from '@modules/story/models/view-models/story-menu-item.view-model';
import { Constants } from '@modules/shared/constants';
import { mediaDownloadAction } from '@app/store/features/media/actions';
import { ConfirmationModalComponent } from '../confirmation-modal';
import { promptAppliesToGuests, promptAppliesToUsers } from '@modules/shared/utils/prompt-audience.util';
@Component({
  selector: 'request-story-campaign-modal',
  templateUrl: './request-story-campaign-modal.component.html',
  styleUrls: ['./request-story-campaign-modal.component.scss'],
  animations: [
    trigger('showhide', [
      // ...
      state('show', style({
        opacity: 1,
        zIndex: '9999'
      })),
      state('hide', style({
        opacity: 0,
        zIndex: '-1'
      })),
      transition('show => hide', [
        animate('0.5s ease-in-out')
      ]),
      transition('hide => show', [
        animate('0.5s ease-in-out')
      ]),
    ]),
    trigger('showhideadthis', [
      // ...
      state('show', style({
        opacity: 1,
        zIndex: 1000
      })),
      state('hide', style({
        opacity: 0,
        zIndex: -1
      })),
      transition('show => hide', [
        animate('0.5s ease-in-out')
      ]),
      transition('hide => show', [
        animate('0.5s ease-in-out')
      ]),
    ]),
  ]
})

export class RequestStoryCampaignContainerComponent extends ComponentModalBase<any> {
  @ViewChild("shareholic") shareholic: ElementRef;
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
  @ViewChild('greetingVideoInput') greetingVideoInput!: ElementRef<HTMLInputElement>;
  public isBrowser:boolean;
  private getMembers$: Observable<UserViewModel[]>;
  private getNextUrl$: Observable<string>;
  private selectPlayerLoading$: Observable<boolean>;
  private selectPlayerLoaded$: Observable<boolean>;
  private selectCurrentCompany$: Observable<CompanyViewModel>;
  private selectCurrentProfile$: Observable<UserProfileViewModel>;
  public upatedCampaignList:any;
  public showRequestedUser:boolean = false;
  public showAuthorDropdown: boolean = false;
  public showemailSection: boolean = false;
  private formChangeSubscription: Subscription;
  private inviteFormchange: Subscription;
  private getNextUrlSubscription: Subscription;
  private selectPlayerLoadingSubscription: Subscription;
  private selectPlayerLoadedSubscription: Subscription;
  private getMembersSubscription: Subscription;
  private selectCurrentCompanySubscription: Subscription;
  private selectCurrentProfileSubscription: Subscription;
  private validateUserSuccessSubscription: Subscription;
  public selectEmailCustomizeListSubscription: Subscription;
  public showEmailEditor:boolean = false;
  public allmails:any;
  public menu;
  private selcetFormSubscription: Subscription;
  private loadQuestionsSubscription: Subscription;
private loadColorSuccessSubscription: Subscription;
  private loadUserInputData: LoadUserInputApiModel = new LoadUserInputApiModel(new PaginationModel(1000));
  private isPlayerAdding: boolean = false;
  public members: any = [];
  public newMembers: any = [];
  public camapignqueston: any[] = [];
  public requestedMembers: any[] = [];
  public username:any;
  public loggedInUserId:any;
  public questionList:any[] = [];
  public searchBarVisible: boolean = false;
  public requestedUsers: any[] = []
  public isCopyCode: boolean = false
  public selectedPeopleIds: any[] = [];
  public isDropdownFocused: boolean = false;
  public isDropdownTyping: boolean = false;
  public searchResultsCount: number | null = null;
  public requestLinksQuery: string = '';
  public showAllRequestLinks: boolean = false;
  public readOnlyforTextfiled: boolean = false;
  public isShowPromptContainer: boolean = false;
  public buttonText: string = 'Copy'
  public userQuestion: any[] = [];
  public guestquestion: any[] = [];
  public isdisplay: boolean = false;
  private loadPermissionSuccessSubscription: Subscription;
  public isSingleInternalRequested: boolean = false;
  public externalUrlforCopy:string;
  public hideSendanCopylinkButton: boolean = false;
  public InternalStorySingleUrl:string;
  public emailSendIngPayload: any [] = [];
  public viewmodel: any = {
    scrollbarVisible: false,
    reachStarted: false,
    reachEnded: false,
    firstLoad: true,
    lastPosition: null,
    fetch: false,
    searching: false,
    isStoryCreating: false,
    isStoryUpdating: false,
    isPlayerCreating: false,
    isPlayerLoading: false,
    isPlayerLoaded: false,
    isInboundCampaign: false,
    //loadingDataOnScroll: false
  };
  public form: UntypedFormGroup;
  public addPlayerForm: UntypedFormGroup;
  public requestForm: UntypedFormGroup;
  public loadMore: boolean = true;
  public stepActive: any;

  selectedLanguages:any[];
  public selectedData: any = [];
  public mediaIndex:any;
  // Kept even when the media step is off, so the gallery panel learns the
  // gallery is turned off and shows that message.
  public mediaStep: any = null;
  public storyData: StoryOutputApiModel;
  public isFormSubmited: boolean = false;
  public companyLogo: string;
  public company: CompanyViewModel;
  public isNoOneSpecific: boolean = false;
  public diableonsearching: boolean = false;
  public isShowNoOneSpecific: boolean = false;
  public isHideErrorEmailInput: boolean = true;
  public isLoading: boolean = false;
  public campaigns: CampaignViewModel[] = [];
  public questionModels:any[] = [];
  private selectCampaign$: Observable<CampaignViewModel[]>;
  private selectCampaignSubscription: Subscription;
  public isDispalyMenu: boolean = false
  public primary_color:any;
  public secondary_button_color:any;
  public isDispalyadthis: boolean = false
  private queryCampaignsData: GetCampaignInputApiModel = new GetCampaignInputApiModel(new PaginationModel(1000));
  public is_not_other_email:boolean = false;
  public uploadedId:any[] = [];
  public showelipse:boolean= false;
  public uploaderViewModel: any = {
    progress: 0,
    progressCss: '0%',
    isUploading: false,
  };
  private greetingMuxUploaderBound = false;
  private pendingGreetingUploadId: string;
  public dataUrl:any;
  public show_video = false;
  public is_video = false;
  public asset_id:any;
  public videoAccepted: boolean = false;
  public sendInternalmail:boolean = false;
  internalUrl: boolean = false;
  @ViewChild('scrollbar')
  scrollbar: ScrollbarComponent;
  loadDataSubscription: Subscription;
  dynamicObject: any;
  loadStepSuccessSubscription: Subscription;
  companyId: number;
  isShowModal: boolean;
  isshowTag: boolean;
  isShowmedia: boolean;
  /** Modal X + collapse-tab accent: white on Add Media, else active menu icon color. */
  public panelCloseColor: string = '#ffffff';
  /** Host class so gallery can sit full-height beside the sticky header. */
  @HostBinding('class.rs-panel-open')
  get rsPanelOpen(): boolean {
    return !!this.isShowModal;
  }
  get isPanelCloseWhite(): boolean {
    const c = (this.panelCloseColor || '').toLowerCase();
    return c === '#fff' || c === '#ffffff' || c === 'white';
  }
  mediaSubscription: Subscription;
  disableSubmit: boolean;
  /** Story state of the page behind this modal, put back on close. */
  private storeSnapshot: RequestStoryStoreSnapshot = null;

  get isGreetingVideoPending(): boolean {
    return !!this.is_video && !this.asset_id;
  }

  public isGreetingRecordingOpen = false;

  get tagsSelectedCount(): number {
    if (!this.dynamicObject) return 0;
    return Object.keys(this.dynamicObject).reduce((total, key) => {
      if (+key === 16) return total;
      const val = this.dynamicObject[key];
      return total + (Array.isArray(val) ? val.length : 0);
    }, 0);
  }

  get mediaSelectedCount(): number {
    if (!this.dynamicObject) return 0;
    const media = this.dynamicObject[16];
    return Array.isArray(media) ? media.length : 0;
  }

  get greetingSelectedCount(): number {
    return this.is_video ? 1 : 0;
  }

  get hasTagsSelected(): boolean {
    return this.tagsSelectedCount > 0;
  }

  get hasMediaSelected(): boolean {
    return this.mediaSelectedCount > 0;
  }

  get isGreetingOpen(): boolean {
    return this.isGreetingRecordingOpen || (!!this.isDispalyMenu && !!this.show_video);
  }

  get isTagsOpen(): boolean {
    return !!this.isShowModal && !!this.isshowTag;
  }

  get isMediaOpen(): boolean {
    return !!this.isShowModal && !!this.isShowmedia;
  }

  constructor(
    private formBuilder: UntypedFormBuilder,
    private store$: Store<CoreState>,
    private detector: ChangeDetectorRef,
    private actions$: Actions,
    private utility: UtilityHelper,
    private router: Router,
    private actions: Actions,
    private toastService: ToastService,
      @Inject(PLATFORM_ID) platformId: Object,
    private requestService: CommentHttpService,
    private storyHttpService: StoryHttpService,
    private modalService: ModalService,
    private storeScope: RequestStoryStoreScope,
  ) {
    super();
        this.isBrowser = isPlatformBrowser(platformId);
    this.getMembers$ = this.store$.select(userSelectors.selectUsers);
    this.getNextUrl$ = this.store$.select(userSelectors.selectNextUrl);
    this.selectPlayerLoading$ = this.store$.select(userSelectors.selectLoading);
    this.selectPlayerLoaded$ = this.store$.select(userSelectors.selectLoaded);
    this.selectCurrentCompany$ = this.store$.select(companySelectors.selectSelectedCompany);
    this.selectCurrentProfile$ = this.store$.select(userProfileSelectors.selectCurrentProfile);
    this.selectCampaign$ = this.store$.select(campaignSelectors.selectAll);

    this.initForm();
  }

  private initForm() {
    this.form = this.formBuilder.group({
      keyword: ['']
    });

    this.requestForm = this.formBuilder.group({
      about: [''],
      bodyCode: [{ value: '', disabled: true }],
      content:[{value: '', disabled: true}],
      campaign: [-1],
      note_email:['', Validators.required],
      requestedUser: [''],
      languageSelected:['en'],
      emailTemplate:['',Validators.required],
      emailSubject:['',Validators.required],
      userselcted: [null],
      externalUserSelcted: [null],
      question:[-1],
      userStatus:['user'],
      emailSendername:[],
      question_id_campaign:[-1],
      addPersonalize:[false],
      firstname:[''],
      lastname:[''],
      message:[''],
      internalmessage:[''],
      users: this.formBuilder.array([this.createUserGroup()]) ,
      greetings:[''],
      email:[]
    });


    this.addPlayerForm = this.formBuilder.group({
      players: this.formBuilder.array([this.createAddPlayerItemForm()])
    });
  }

  private createAddPlayerItemForm() {
    return this.formBuilder.group({
      firstName: ['', Validators.required],
      email: ['', Validators.compose([this.emailValidator.bind(this), Validators.email])]
    });
  }

  protected onInit(): void {
    if(this.isBrowser){
    navigator.mediaDevices
    .getUserMedia({ audio: true,video:true })
    .then((stream)=>{
      stream.getTracks().forEach(track => track.stop());
    })
    }

    this.selectedLanguages = this.getLanguagesFromStorage()
    if (this.isBrowser) {
      this.storeSnapshot = this.storeScope.enter();
    }
    this.subscribe();
    //console.log(">>",this.initialState)
  }
  protected onDestroy(): void {
    // Restore first so picks never leak into the next modal or Submit Story.
    if (this.isBrowser) {
      this.storeScope.leave(this.storeSnapshot);
    }
    this.unSubscribe();
  }


  protected onChanges(changes: SimpleChanges): void {

  }
  protected onDoCheck(): void {

  }
  protected onAfterContentInit(): void {

  }
  protected onAfterContentChecked(): void {
  }
  protected onAfterViewInit(): void {
    // $(document).on('click','#cancel-request-btn',function(event){
    //   close()
    // })
  }

  protected onAfterViewChecked(): void {

  }

  private subscribe() {

        this.mediaSubscription = this.actions$.pipe(
          ofType<mediaDownloadAction.CheckDownloaf>(mediaDownloadAction.ActionTypes.CHECK_DOWNLOAD)
        ).subscribe((action: any) => {
            if(action.download){
              this.disableSubmit = true;
            }
            else{
              this.disableSubmit = false;
            }
          
    
        })
    this.inviteFormchange = this.requestForm.valueChanges.pipe(
      debounceTime(100)
    ).subscribe((value) => {
  
      if(this.externalUrlforCopy && !this.showemailSection){
        this.isSingleInternalRequested = false;
      }

      // After links exist, any form edit clears them so Create Link regenerates unique URLs.
      if (this.isCopyCode && !this.sendInternalmail) {
        this.invalidateCreatedRequestLinks();
        return;
      }
  
      if(this.internalUrl && !this.sendInternalmail){
        this.hideSendanCopylinkButton = false;
      }
  
  
    })
    this.formChangeSubscription = this.form.controls['keyword'].valueChanges.pipe(
      debounceTime(900)
    ).subscribe((value) => {
      this.viewmodel.searching = true;
      this.loadUserInputData.search = value && value.trim() || '';
      this.loadUserInputData.pagination.page = 1;
      this.loadUserInputData.pagination.sort = 'desc'

      // setTimeout(()=>{
      //   this.scrollbar.scrollToTop(0);
      // },1000)

      if (this.loadUserInputData.search.length === 0) {
        this.diableonsearching = false;
        this.resetSearchForm();
      } else {
        this.diableonsearching = true;
        this.loadMembers([]);
      }
    });


    this.loadDataSubscription = this.actions$.pipe(
      ofType<storyStepActions.AddToObject>(storyStepActions.ActionTypes.ADD_TO_OBJECT) // listen for the action
    ).subscribe((action: any) => {
      
      // If key doesn't exist, create it
  
     this.dynamicObject = {
        ...this.dynamicObject,   // keep existing keys
        ...action.value          // add/overwrite new keys
      };
      if(this.externalUrlforCopy){
        this.isSingleInternalRequested = false;
      }
  
      if (this.isCopyCode) {
        this.invalidateCreatedRequestLinks();
      } else if (this.internalUrl) {
        this.hideSendanCopylinkButton = false;
      }
    
      // console.log('Merged dynamicObject in Component B:', this.dynamicObject);
    });
    
    this.loadDataSubscription = this.actions$.pipe(
      ofType<storyStepActions.AddMediaObject>(storyStepActions.ActionTypes.ADD_MEDIA_TO_OBJECT) // listen for the action
    ).subscribe((action: any) => {
      
      // If key doesn't exist, create it
  
      this.dynamicObject = {
        ...this.dynamicObject,   // keep existing keys
        ...action.value          // add/overwrite new keys
      };
      if(this.externalUrlforCopy){
        this.isSingleInternalRequested = false;
      }

      if (this.isShowmedia) {
        return;
      }
  
      if (this.isCopyCode) {
        this.invalidateCreatedRequestLinks();
      } else if (this.internalUrl) {
        this.hideSendanCopylinkButton = false;
      }
    
      // console.log('Merged dynamicObject in Component B:', this.dynamicObject);
    });
    this.loadColorSuccessSubscription = this.actions$.pipe(
      ofType<storyActions.GetColorSuccess>(storyActions.ActionTypes.GET_BUTTON_COLOR_SUCCESS)
    ).subscribe((action: any) => {
      if(action && action.response && action.response && action.response.length){
        this.primary_color = action.response.find(item => item.button == 11).color;
        this.secondary_button_color = action.response.find(item => item.button == 8)?.color;
       }
      

    })

    this.loadPermissionSuccessSubscription =  this.actions$.pipe(
      ofType<userPermissionActions.LoadPermissionsSuccess>(userPermissionActions.ActionTypes.LOAD_PERMISSION_SUCCESS)
    ).subscribe((action: any) => {
     if(action.response && action.response.length){
      this.showRequestedUser = action.response.find(permission => permission.name === 'requested_user_details');
     }
    })

    this.selectCampaignSubscription = this.selectCampaign$.subscribe((campaigns) => {
      if (!campaigns?.length) {
        return;
      }
      this.campaigns = campaigns.filter(camp => camp.daysLeft > 0) || [];
      this.rebuildQuestionModels();
    });

    this.getNextUrlSubscription = this.getNextUrl$.subscribe((nextUrl) => {
      this.loadMore = nextUrl !== null;
    });

    this.selectPlayerLoadingSubscription = this.selectPlayerLoading$.subscribe((isLoading: boolean) => {
      this.viewmodel.isPlayerLoading = isLoading;
    });

    this.selectPlayerLoadedSubscription = this.selectPlayerLoaded$.subscribe((isLoaded: boolean) => {
      this.viewmodel.isPlayerLoaded = isLoaded;
    });

    this.selectCurrentCompanySubscription = this.selectCurrentCompany$.subscribe((company) => {
      if (company) {
        this.companyLogo = company.logo;
        this.company = company;
        this.store$.dispatch(new storyActions.GetColor(this.company.id));
        this.is_not_other_email = this.isEmailDomainAllowed(this.initialState.email, company.domains)
        if(!this.is_not_other_email){
          this.requestForm.controls.emailSendername.setValue(this.company?.requested_from_name)
        }
      }
    });

    this.getMembersSubscription = this.getMembers$.subscribe((members) => {
      this.viewmodel.searching = false;
     // this.viewmodel.loadingDataOnScroll = false;
      this.detector.detectChanges();
      this.viewmodel.isInboundCampaign = (this.viewmodel.inbound && this.company.isCampaignCompany);
      if (!this.viewmodel.isInboundCampaign) {
         this.members = members;
         this.requestedMembers = this.members.map((member)=>{
          return {
            title:member.displayName,
            id:member.id
          }
         })
         if(this.requestedMembers.length && this.loggedInUserId){
          let loggedIn ={
            id:this.loggedInUserId,
            title:this.username
          }
          this.requestedMembers.unshift(loggedIn)
        }
  
      }
      this.updateSelectedValues();
    });


      this.loadStepSuccessSubscription = this.actions$.pipe(
        ofType<storyStepActions.LoadSuccess>(storyStepActions.ActionTypes.LOAD_SUCCESS)
      ).subscribe((result) => {
        if(result){
            this.stepActive = result.data.filter( stp => stp.id != 17 && stp.id != 5 && stp.is_active != 0);
                this.menu =  result.data.filter(stp => stp.id != 17 && stp.id != 16 && stp.id != 5 && stp.is_active != 0).map(r => {
                    const menuItem = new StoryFlowMenuItemViewModel();
                    menuItem.id = r.id;
                    menuItem.title = r.title;
                    menuItem.icon = Constants.stepIcon.getStepIcon(this.istitle(r.id).replace(/\s+/gi, ''));
                    menuItem.color = r.color;
                    return menuItem;
                });
                this.mediaIndex = this.stepActive.findIndex(menu => menu.id == 16)
                this.mediaStep = result.data.find(stp => stp.id == 16) || null;
                // Add Media / Add Tags clicked before the steps arrived sent no step,
                // so the gallery assumed galleries were off and showed the flat list.
                this.syncOpenPanelStep();
        }
    
      })
    

    this.selectCurrentProfileSubscription = this.selectCurrentProfile$.subscribe((userProfile) => {
      if (userProfile) {
        this.companyLogo = userProfile.company.logo;
        this.viewmodel.inbound = false;
        this.loggedInUserId = userProfile.id
        this.companyId = userProfile?.company?.id
                this.store$.dispatch(new storyBuilderActions.SetInbound(false));
                this.store$.dispatch(new storyBuilderActions.SetCompanyId(this.companyId));
                // this.store$.dispatch(new storyStepActions.Load(this.companyId, false, '', true));
                this.store$.dispatch(new storyStepActions.Load(this.companyId, false, '', false));
        this.username = userProfile.displayName
        this.viewmodel.companyId = userProfile.company.id;
        this.store$.dispatch(new emailCustomizeSettingAction.Load(this.viewmodel.companyId));
        this.selectedData = [];
        this.playersFormArray.controls.forEach((fgItem: UntypedFormGroup) => {
          fgItem.controls.email.updateValueAndValidity();
        });
        this.store$.dispatch(new storyStepActions.LoadQuestions(userProfile.company.id))
        this.updateSelectedValues();
        this.updateSelectedNoOneSpecific();
        this.loadMembers(this.selectedData);
        this.queryCampaignsData.isLoadExpired = false;
        this.queryCampaignsData.pagination.sort = 'desc';
        this.queryCampaignsData.isIncludeStories = true;
        this.queryCampaignsData.public = false;
        this.queryCampaignsData.pagination.limit = 100;
        this.store$.dispatch(new userPermissionActions.LoadPermissions());
        this.store$.dispatch(new campaignActions.Load(userProfile.company.id, this.queryCampaignsData));
      }
    });

    this.selectEmailCustomizeListSubscription = this.actions$.pipe(
      ofType<emailCustomizeSettingAction.LoadSuccess>(emailCustomizeSettingAction.ActionTypes.LOAD_SUCCESS)
    ).subscribe((result: any) => {
      if (result && result.response && result.response.length) {
          this.allmails = result.response;
          if(this.requestForm.value.userStatus == 'Guestuser'){
            this.requestForm.controls.emailTemplate.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').body);
            this.requestForm.controls.emailSubject.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').subject);
          }
          else{
            this.requestForm.controls.emailTemplate.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').body);
            this.requestForm.controls.emailSubject.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').subject);
          }
      }
    });

    this.validateUserSuccessSubscription = this.actions.pipe(
      ofType<userActions.ValidateUserSuccess>(userActions.ActionTypes.VALIDATE_USER_SUCCESS)
    ).subscribe((action: userActions.ValidateUserSuccess) => {
      this.validateUsersSuccess(action.response);
    });
    this.loadQuestionsSubscription = this.actions$.pipe(
      ofType<storyStepActions.LoadQuestionsSuccess>(storyStepActions.ActionTypes.LOAD_QUESTIONS_SUCCESS)).
        subscribe((questions: any) => {
         if(questions && questions.data && questions.data && questions.data.length){
          this.questionList= questions.data.filter(question => question.is_active == 1);
          if(this.questionList.length){
            const nonQuestion = {
              id:-1,
              is_active:null,
              question_text: 'Select option'

            }
            this.userQuestion = this.questionList.filter(item => promptAppliesToUsers(item));
            this.guestquestion = this.questionList.filter(item => promptAppliesToGuests(item));
            this.userQuestion.unshift(nonQuestion);
            this.guestquestion.unshift(nonQuestion)

          }

         }
      })

    this.selcetFormSubscription = this.requestForm.controls.requestedUser.valueChanges.subscribe((data: any) => {
      this.requestForm.controls.bodyCode.setValue(data)
    })

  }
  isEmailDomainAllowed(email, domains) {
    if (!email || !email.includes("@")) return false;
  
    const emailDomain = email.split("@")[1].toLowerCase();
    return domains.some(d => d.domain.toLowerCase() === emailDomain);
  }
  showSearchBar(): void {
    this.searchBarVisible = true;
    setTimeout(() => {
      document.getElementById("searchUnsplash").focus();
    }, 100);
  }

  private unSubscribe() {
    this.formChangeSubscription.unsubscribe();
    this.getNextUrlSubscription.unsubscribe();
    this.selectPlayerLoadingSubscription.unsubscribe();
    this.selectPlayerLoadedSubscription.unsubscribe();
    this.getMembersSubscription.unsubscribe();
    this.selectCurrentCompanySubscription.unsubscribe();
    this.selectCurrentProfileSubscription.unsubscribe();
    this.validateUserSuccessSubscription.unsubscribe();
    this.selcetFormSubscription.unsubscribe();
    this.loadPermissionSuccessSubscription.unsubscribe();
    this.loadColorSuccessSubscription.unsubscribe();
  }

  istitle(id): string{
    if(!this.isBrowser) return;
    var path = ''
    switch (id) {
      case 2:
        path = 'Teams';
        break;

      case 5:
        path = 'People';
        break;

      case 8:
        path = 'Skills';
        break;

      case 11:
        path = 'Challenges';
        break;
      case 13:
        path = 'Vibes';
        break;

      case 14:
        path = 'Values';
        break;

      case 16:
        path = 'Media';
        break;

    }
    return path
  }

  private rebuildQuestionModels(): void {
    this.questionModels = [];
    let scoped = this.campaigns || [];
    if (this.initialState?.id) {
      scoped = scoped.filter(c => c.id === this.initialState.id);
    }
    for (const campaign of scoped) {
      if (!Array.isArray(campaign.storyPrompt)) {
        continue;
      }
      const storyprompts = campaign.storyPrompt.filter(
        item => item.is_stories || item.is_campaign
      );
      for (const prompt of storyprompts) {
        this.questionModels.push({
          storyPrompt: prompt.story_prompt,
          campaign_id: campaign.id,
          id: +prompt.id,
          position: this.questionModels.length,
        });
      }
    }
    this.detector.detectChanges();
  }

  private loadMembers(selectedData: any[]) {
    this.loadUserInputData.inbound = this.viewmodel.inbound;
    this.loadUserInputData.companyId = this.viewmodel.companyId;
    this.loadUserInputData.pagination.sort = 'desc'
    selectedData = selectedData || [];
    this.loadUserInputData.selectedValues = selectedData.filter(id => this.utility.Lodash.isNumber(id) && id > 0);
    let selectedEmails: string[] = [];
    const idsAsString = selectedData.filter(id => this.utility.Lodash.isString(id));
    idsAsString.forEach((sData: string) => {
      const emailParserRes = this.utility.StringHelper.emailParser(sData);
      selectedEmails.push(emailParserRes.email);
    });
    this.loadUserInputData.selectedEmails = selectedEmails;
    this.store$.dispatch(new userActions.Load(this.loadUserInputData));
  }

  private updateSelectedValues() {
    const searchValue = this.form.controls.keyword.value;
    if (searchValue) {
      this.members = [...this.newMembers, ...this.members].filter(member => member.displayName.toLowerCase().includes(searchValue.toLowerCase()) || member.email.toLowerCase().includes(searchValue.toLowerCase()));
    } else {
      this.members = [...this.newMembers, ...this.members];
    }
    this.members.forEach((member: UserViewModel) => {
      member.checked = this.selectedData && (this.selectedData.indexOf(member.id) > -1 || this.selectedData.findIndex(f => isString(f) && f.indexOf(member.email) > -1) > -1);
    });
    this.selectedPeopleIds = (this.selectedData || []).filter((id) => this.utility.Lodash.isNumber(id) && id > 0);
    if(this.members.length){
      const selectedMembers = this.members.filter(member => member.checked);
      if(selectedMembers.length){
        this.diableonsearching = false;
      }
    }
    this.playersFormArray.controls[0].get('firstName').patchValue(searchValue);
    
  }

  private updateSelectedNoOneSpecific() {
    this.isNoOneSpecific = false;
    if (this.selectedData && this.selectedData.indexOf(-1) > -1) {
      this.isNoOneSpecific = this.selectedData && this.selectedData.indexOf(-1) > -1;
    }
  }

  private resetAddPlayerForm() {
    this.addPlayerForm.reset();
    this.addPlayerForm.setControl('players', this.formBuilder.array([this.createAddPlayerItemForm()]));
    this.isFormSubmited = false;
  }

  private resetSearchForm() {
    this.form.reset({}, { emitEvent: false });
    this.loadUserInputData.search = '';
    this.loadMembers(this.selectedData);
  }

  private addPlayerSuccess() {
    this.updateSelectedValues();
    this.resetAddPlayerForm();
    this.resetSearchForm();
    this.viewmodel.isPlayerCreating = false;
    this.updateData();
  }

  private emailValidator(control: UntypedFormControl) {
    let value = control.value;
    if (!this.viewmodel.inbound && (!value || value.length === 0)) {
      return 'String empty';
    }
    return null;
  }

  private validateUsers() {
    const emails = this.playersFormArray.value.map(player => player.email);
    this.store$.dispatch(new userActions.ValidateUser(emails));
  }

  private validateUsersSuccess(vuRes: ValidateUserOutApiModel[]) {
    this.playersFormArray.controls.forEach((fgItem: UntypedFormGroup) => {
      const checkAllowAddToStory = vuRes.find(f => f.email === fgItem.controls.email.value && f.story_invite_enabled === true);
      if (!checkAllowAddToStory) {
        this.isHideErrorEmailInput = false;
        fgItem.controls.email.setErrors(
          {
            isCustom: true,
            message: 'Unavailable to add. Please try another email!'
          }
        );
      }
    });

    this.addPlayer();
  }

  private addPlayer() {
    if (!this.addPlayerForm.valid) {
      this.viewmodel.isPlayerCreating = false;
      return;
    }

    this.isPlayerAdding = true;
    this.playersFormArray.controls.forEach((fgItem: UntypedFormGroup) => {
      let createUserData = new UserViewModel(null);
      createUserData.firstname = fgItem.controls.firstName.value;
      createUserData.lastname = '';
      createUserData.email = fgItem.controls.email.value || '';
      createUserData.displayName = `${createUserData.firstname}`;
      createUserData.id = `${createUserData.firstname} <${createUserData.email}>`;
      createUserData.checked = true;
      this.newMembers.unshift(createUserData);
      this.selectedData = this.selectedData || [];
      const newUserValue = `${createUserData.firstname} <${createUserData.email}>`;
      this.selectedData.push(newUserValue);
    });
    this.addPlayerSuccess();
  }

  public onYReachEnd() {
    if (this.loadMore && this.viewmodel.scrollbarVisible && !this.isCopyCode && this.router.url != '/directory') {
      this.loadUserInputData.pagination.page += 1;
      //this.viewmodel.loadingDataOnScroll = true;
      this.loadMembers([]);
    }
  }

  public onPositionChanged() {
    this.viewmodel.scrollbarVisible = true;
    if (this.loadMore && this.viewmodel.scrollbarVisible && !this.isCopyCode && this.router.url == '/directory') {
      this.loadUserInputData.pagination.page += 1;
      this.viewmodel.loadingDataOnScroll = true;
      this.loadMembers([]);
    }
  }

  public selectItem(player: UserViewModel) {
    this.selectedData = this.selectedData && this.selectedData.filter((id: number) => (this.utility.Lodash.isNumber(id) && id > 0) || this.utility.Lodash.isString(id)) || [];
    this.isNoOneSpecific = false;
    this.form.controls.keyword.reset()
    this.diableonsearching = false;

    if (player.checked === true) {
      this.selectedData.push(player.id);
    } else {
      const index = this.selectedData.findIndex(f => f === player.id);
      this.selectedData.splice(index, 1);
    }

    this.selectedPeopleIds = [...this.selectedData];
    this.updateData();
  }

  public checkDisabled(member: any) {
    return this.selectedData && this.selectedData.length >= 3 && !member.checked;
  }

  public memberTrackByFnc(item) {
    return item.id;
  }

  public addPlayerFormSubmit() {
    const emails = this.playersFormArray.value.map(player => player.email);
    // emails.forEach(email => {
    //   const splitEmail = email.split('@');
    //   const emailDomain = splitEmail[1];
    //   if (!this.company.domains.find(domain => domain.domain === emailDomain)) {
    //     this.playersFormArray.controls.forEach((fgItem: FormGroup) => {
    //       if (fgItem.controls.email.value === email) {
    //         this.isHideErrorEmailInput = false;
    //         fgItem.controls.email.setErrors(
    //           {
    //             isCustom: true,
    //             message: 'Invalid domain!'
    //           }
    //         );
    //       }
    //     });
    //   }
    // });
    if (this.addPlayerForm.invalid) return;
    this.isFormSubmited = true;
    this.viewmodel.isPlayerCreating = true;

    this.validateUsers();
  }

  public updateData() {
    this.loadMembers(this.selectedData);
  }

  public handleComKeyEnter() {
  }

  changeData(data){
    if(typeof data === 'string' ){
      if(data != '-1'){
        this.requestForm.controls.about.setValue(this.questionList.find(item => item.id == +data).question_text)
        this.readOnlyforTextfiled = false;
        this.requestForm.controls.campaign.reset();
        this.requestForm.controls.campaign.setValue(-1);
        this.requestForm.controls.question_id_campaign.setValue(-1)

      }
  
 
    }
  }


  public exceptHandleComKeyEnter(event) {
    event.stopPropagation();
  }
  public exceptHandleComKeyEnterKey(event) {
    event.stopPropagation();
  }

  get playersFormArray() {
    return this.addPlayerForm.get('players') as UntypedFormArray;
  }

  public addPlayerFormItem() {
    this.playersFormArray.push(this.createAddPlayerItemForm());
  }

  public removeAddPlayerFormItem($event, index) {
    $event.stopPropagation();
    this.playersFormArray.removeAt(index);
  }



  cancel() {
    this.onClose.emit(false);
  }
  

  GenearateInternalLink() {
    this.isLoading = true;
    const selectedMembers = this.members.filter(member => member.checked);
    this.showEmailEditor = false;
    if (selectedMembers.length) {
      let payload = {
        author_emails: selectedMembers.map((member: UserViewModel) => { return member.email }),
        campaign_id: this.initialState.id,
        story_requested: 1,
        interview_style: this.initialState.interview_style
      }
      payload['is_video'] = this.is_video;
      payload['asset_id'] = this.asset_id;
      payload['emailTemplate'] = this.requestForm.controls.emailTemplate.value;
      payload['emailSubject'] = this.requestForm.controls.emailSubject.value;
      payload['story_steps'] = this.dynamicObject;
      if(this.requestForm.value.internalmessage){
        payload['message']=this.requestForm.value.internalmessage
      }
      const requestorId = this.requestForm.value.userselcted;
      if (requestorId && +requestorId !== +this.loggedInUserId) {
        payload['requested_by_id'] = requestorId;
      }

      if(this.requestForm.value.languageSelected){
        payload['lang_code'] = this.requestForm.value.languageSelected;
      }

      if(this.internalUrl){
        payload['old_url'] = this.members;
        payload['is_internal'] = true;
     }
      this.requestService.request(payload).subscribe({
        next: (data: any) => {
          this.isLoading = false;
          this.isCopyCode = true;
          this.requestedUsers = data
          this.checkForSelectedUsers(data);
          this.requestForm.patchValue({
            requestedUser: data[0].url,
            bodyCode: data[0].url
          },{emitEvent: false})
        },
        error: () => {
          this.isLoading = false;
          this.toastService.error(
            'Could not create the request link. Wait a moment and try again.'
          );
        },
      })
    }
    else{
      this.isLoading = false;
      this.toastService.warning("Please select any option to continue")
    }
  }

    createUserGroup(): FormGroup {
      return this.formBuilder.group({
        firstName: ['', Validators.required],
        author_email: ['', [Validators.email,Validators.required]]
      });
    }
  
    get users(): FormArray {
      return this.requestForm.get('users') as FormArray;
    }
    addUser(): void {
      this.users.push(this.createUserGroup());
    }
    
    removeUser(index: number): void {
      if (this.users.length > 1) {
        this.users.removeAt(index);
      }
    }
  
    get lastUserValid(): boolean {
      const usersArray = this.users;
      const last = usersArray.at(usersArray.length - 1);
      return last?.valid ?? false;
    }
  GenearateExternalLink() {
    this.isLoading = true;
      let payload = {
        author_emails:  [],
        campaign_id: this.initialState.id,
        story_requested: 1,
        interview_style: this.initialState.interview_style
      }
      payload['is_video'] = this.is_video;
      payload['asset_id'] = this.asset_id;
      payload['emailTemplate'] = this.requestForm.controls.emailTemplate.value;
      payload['emailSubject'] = this.requestForm.controls.emailSubject.value;
      payload['story_steps'] = this.dynamicObject;
      this.showEmailEditor = false;
      if(this.requestForm.controls.firstname.value){
        payload['firstname']=this.requestForm.controls.firstname.value;
      }

      if(this.requestForm.value.languageSelected){
        payload['lang_code'] = this.requestForm.value.languageSelected;
      } 

      if(this.requestForm.controls.lastname.value){
        payload['lastname']=this.requestForm.controls.lastname.value;
      }
      
      if(this.requestForm.controls.note_email.value){
        payload['note_email']=this.requestForm.controls.note_email.value;
      }
      if(this.requestForm.value.message){
        payload['message']=this.requestForm.value.message
      }
      const externalRequestorId = this.requestForm.value.externalUserSelcted;
      if (externalRequestorId && +externalRequestorId !== +this.loggedInUserId) {
        payload['requested_by_id'] = externalRequestorId;
      }

      if(this.externalUrlforCopy){
        payload['url'] = this.externalUrlforCopy;
      }
      this.requestService.request(payload).subscribe((data: any) => {
        this.isLoading = false;
        this.requestedUsers = data
  
        // this.requestForm.controls.emailTemplate.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').body);
        // this.requestForm.controls.emailSubject.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').subject);
        this.checkForExternalSelectedUsers(data);
        // this.isShowModal = false;
        // this.resetModalWidth();
        // this.resetState()
      })
    }
  

  
    private checkForExternalSelectedUsers(data){
      // this.requestForm.controls.firstname.disable();
      // this.requestForm.controls.lastname.disable();
      // this.requestForm.controls.email.disable();
      this.isdisplay = true;
      var tempDatastorage = []
      this.hideSendanCopylinkButton = true;
      this.isSingleInternalRequested = true;
      if(data.length == 1){
      
         this.externalUrlforCopy  = data[0].url;
          if(data && data[0].story && data[0].story?.storyid){
            let emailPaylooad = {}
            let emails =  {
              author_email: data[0].email,
              story_id: data[0].story?.id
             }


             this.emailSendIngPayload.push(emails)
          }
          else{
            let emailPayload  =  {
              author_emails: this.requestForm.controls.users.value,
              // firstname:this.requestForm.value.firstname,
              // lastname:this.requestForm.value.lastname,
              // campaign_id: this.initialState.id,
              // story_requested: 1
             }
            this.emailSendIngPayload.push(emailPayload)
            // this.isSingleInternalRequested = true;
          }
         
      }
  
  
    }

    sendExternalEmail(){

          this.isShowModal = false;
        this.resetModalWidth();
      if(!this.showemailSection){
        this.showemailSection = true;
  
      }
      else{
      let emails = {
        author_emails:this.requestForm.controls.users.value,
        emailTemplate: this.requestForm.controls.emailTemplate.value,
        emailSubject:  this.requestForm.controls.emailSubject.value,
        link:this.externalUrlforCopy
      }
      const externalEmailRequestorId = this.requestForm.value.externalUserSelcted;
      if (externalEmailRequestorId && +externalEmailRequestorId !== +this.loggedInUserId) {
        emails['requested_by_id'] = externalEmailRequestorId;
      }
      this.store$.dispatch(new storyAction.SendEamilInternalExternal(emails));
      this.toastService.success('Sent');
      // this.requestForm.controls.firstname.reset();
      // this.requestForm.controls.lastname.reset();
      // this.requestForm.controls.email.reset();
      // this.requestForm.controls.users.reset();
      // this.showemailSection = false;
      // this.resetState();
      // this.externalUrlforCopy = '';
      // this.emailSendIngPayload = [];
      // this.isSingleInternalRequested = false;
      // this.hideSendanCopylinkButton = false;
    }
    }

  private checkForSelectedUsers(data: any) {
    this.isdisplay = true;
    var tempDatastorage = []
    this.hideSendanCopylinkButton = true;
    this.internalUrl = true;
    this.emailSendIngPayload = [];
    if(data.length == 1){
       this.InternalStorySingleUrl  = data[0].url;
       let emailPaylooad  =  {
        author_email: data[0].email,
        story_id: data[0].story?.id,
        campaign_id:this.initialState.id,
        interview_style: this.initialState.interview_style
       }
       this.emailSendIngPayload.push(emailPaylooad)
       this.members.forEach((item, i) => {
        data.forEach((items, j) => {
          if (items.email == item.email) {
            item["url"] = items.url
            item["story_id"] = data[0].story?.id;
            tempDatastorage.push(item)
          }
        })
      })
  this.members = [];
  this.members = tempDatastorage
    }
    else if (data.length > 1 ){
        data.forEach((author)=>{
           let multipleEmailPayload = {
            author_email: author.email,
            story_id: author.story?.id,
            campaign_id:this.initialState.id,
            interview_style: this.initialState.interview_style
           } 
           this.emailSendIngPayload.push(multipleEmailPayload)
        })
        this.hideSendanCopylinkButton = true;
        this.members.forEach((item, i) => {
          data.forEach((items, j) => {
            if (items.email == item.email) {
              item["url"] = items.url;
              item["story_id"] = data[0].story?.id,
              tempDatastorage.push(item)
            }
          })
        })
    this.members = [];
    this.members = tempDatastorage
    }


    
  }

  chnageExternaladdPersonalize(data){
  //  this.requestForm.controls.firstname.reset();
  //  this.requestForm.controls.lastname.reset();
  //  this.requestForm.controls.email.reset();
   this.externalUrlforCopy = '';
   this.emailSendIngPayload = [];
   this.isSingleInternalRequested = false;
   this.hideSendanCopylinkButton = false;
   if(this.requestForm.value.addPersonalize){
    this.requestForm.get('message').updateValueAndValidity();
    this.requestForm.get('message').setValidators([Validators.required]);
   }
   else{
    this.requestForm.get('message').clearValidators();
    this.requestForm.get('message').updateValueAndValidity();
    this.userstatus(null)
   }
  }

  sendIntenalEmail(){
    let emails = {
      author_emails: this.emailSendIngPayload,
      emailTemplate: this.requestForm.controls.emailTemplate.value,
      emailSubject:  this.requestForm.controls.emailSubject.value,
    }
    const emailRequestorId = this.requestForm.value.userselcted;
    if (emailRequestorId && +emailRequestorId !== +this.loggedInUserId) {
      emails['requested_by_id'] = emailRequestorId;
    }
    if(!this.is_not_other_email){
      emails['request_sender_name'] = this.requestForm.value.emailSendername;
    }

    if(this.requestForm.value.languageSelected){
      emails['lang_code'] = this.requestForm.value.languageSelected;
    }
    this.store$.dispatch(new storyAction.SendEamilInternalExternal(emails));
    this.toastService.success('Sent')
    // this.requestForm.();
    // this.requestForm.controls.internalmessage.reset();
    // this.members = [];
    // this.selectedData = [];
    // this.emailSendIngPayload = [];
    // this.isCopyCode = false;
    // this.sendInternalmail = false;
    // this.internalUrl = false;
    // this.resetState()
    // this.hideSendanCopylinkButton = false;
    // this.requestForm.controls.userStatus.setValue('user');
    // this.loadUserInputData.pagination.page = 1;
    // this.loadUserInputData.pagination.sort = 'desc'
    // this.toastService.success('Sent')
    // this.loadMembers([]);
  }

  Changecampaigns(data){
    if(typeof data === 'string' && data != '-1'){
       //console.log(data);
       let storyPrompt = this.questionModels.find(item => item.id == +data)
       if(storyPrompt){
        // this.requestForm.controls.about.setValue(storyPrompt.storyPrompt);
        this.requestForm.controls.campaign.setValue(storyPrompt.campaign_id)
       }
       else{
        this.requestForm.controls.about.setValue('');
       }

       this.readOnlyforTextfiled = true;
       this.requestForm.controls.question.reset();
       this.requestForm.controls.question.setValue(-1);
    }
  }

  sendEmail(){

  }

  userstatus(userType: 'user' | 'Guestuser' | null){
    // Clicking the tab that is already active must not wipe the form.
    if (userType && userType === this.requestForm.value.userStatus) {
      return;
    }
    // User and Guest use separate message controls; carry message, media, and tags over a real switch.
    // Keep greeting too (do not call removeVideo).
    const carry = userType
      ? this.captureUserSwitchCarryOver()
      : { message: '', media: [] as number[], tagSteps: {} as { [stepId: number]: number[] } };
    
    // Set the form control value first if userType is provided
    if (userType) {
      this.requestForm.controls.userStatus.setValue(userType);
      
      if (userType === 'Guestuser') {
        const noteEmail = this.requestForm.controls.note_email;
        if (!noteEmail.value) {
          noteEmail.markAsPristine();
          noteEmail.markAsUntouched();
        }
      }
    }

    // Clear other picks but keep company id + carried media/tags: a full store
    // reset left the gallery on company 0, which the API serves as GoodSeeker stock.
    this.storeScope.clearSelections(
      this.companyId,
      this.requestForm.value.userStatus == 'Guestuser',
      carry.media,
      carry.tagSteps
    );
    this.dynamicObject = {};
    if (carry.media.length) {
      this.dynamicObject[Constants.storyStep.media] = [...carry.media];
    }
    Object.keys(carry.tagSteps || {}).forEach((stepId) => {
      const ids = carry.tagSteps[stepId];
      if (ids && ids.length) {
        this.dynamicObject[stepId] = [...ids];
      }
    });
    this.isShowModal = false;
    this.resetModalWidth();
    this.internalUrl = false;
    this.sendInternalmail = false;
    this.showAuthorDropdown = false;
    if(this.requestForm.value.userStatus == 'Guestuser' && !this.isSingleInternalRequested){
       this.requestForm.get('email').updateValueAndValidity();
       this.requestForm.get('email').setValidators([Validators.email]);
       this.store$.dispatch(new storyBuilderActions.SetInbound(true));
       this.store$.dispatch(new storyStepActions.Load(this.companyId, true, '', false));
       this.isSingleInternalRequested = false;
       this.hideSendanCopylinkButton = false;
       this.emailSendIngPayload = [];
       this.isShowPromptContainer = false;
    }
    else if(this.requestForm.value.userStatus == 'Guestuser'  &&  this.isSingleInternalRequested){
      this.requestForm.controls.firstname.disable();
      this.requestForm.controls.lastname.disable();
      this.requestForm.controls.email.disable();
      this.requestForm.controls.note_email.disable();
      this.store$.dispatch(new storyBuilderActions.SetInbound(true));
      this.store$.dispatch(new storyStepActions.Load(this.companyId, true, '', false));
      this.isSingleInternalRequested = true;
      this.hideSendanCopylinkButton = true;
      this.emailSendIngPayload = [];
      this.isShowPromptContainer = false;
      
   }
    else{
      if(!this.isCopyCode){
        this.members = [];
        this.selectedData = [];
        this.isCopyCode = false;
        this.loadUserInputData.pagination.page = 1;
        this.loadUserInputData.pagination.sort = 'desc'
        this.loadMembers([]);
        this.store$.dispatch(new storyBuilderActions.SetInbound(false));
        this.store$.dispatch(new storyStepActions.Load(this.companyId, false, '', false));
        this.requestForm.controls.userStatus.setValue('user');
        this.hideSendanCopylinkButton = false;
        this.emailSendIngPayload = [];
        this.isShowPromptContainer = false;
        this.requestForm.controls.internalmessage.reset();
      }
      else{
        this.requestForm.controls.internalmessage.reset();
        this.requestForm.controls.userStatus.setValue('user');
        this.hideSendanCopylinkButton = true;
        this.store$.dispatch(new storyBuilderActions.SetInbound(false));
        this.store$.dispatch(new storyStepActions.Load(this.companyId, false, '', false));
        this.requestForm.controls.internalmessage.reset();;

      }

    }
     this.showemailSection = false;
    this.requestForm.controls.emailTemplate.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').body);
    this.requestForm.controls.emailSubject.setValue(this.allmails.find(email => email.title === 'TO A USER - when some requests a story from them').subject);
    if (carry.message) {
      const isGuest = this.requestForm.value.userStatus == 'Guestuser';
      (isGuest ? this.requestForm.controls.message : this.requestForm.controls.internalmessage).setValue(carry.message);
    }
  }

  private captureUserSwitchCarryOver(): {
    message: string;
    media: number[];
    tagSteps: { [stepId: number]: number[] };
  } {
    const controls = this.requestForm.controls;
    const wasGuest = this.requestForm.value.userStatus == 'Guestuser';
    const media = this.dynamicObject && Array.isArray(this.dynamicObject[Constants.storyStep.media])
      ? [...this.dynamicObject[Constants.storyStep.media]]
      : [];
    const tagSteps: { [stepId: number]: number[] } = {};
    if (this.dynamicObject) {
      Object.keys(this.dynamicObject).forEach((key) => {
        const stepId = +key;
        if (stepId === Constants.storyStep.media) return;
        const ids = this.dynamicObject[key];
        if (Array.isArray(ids) && ids.length) {
          tagSteps[stepId] = [...ids];
        }
      });
    }
    return {
      message: (wasGuest ? controls.message.value : controls.internalmessage.value) || '',
      media,
      tagSteps
    };
  }
  public widenRequestModal(): void {
    if (!this.isBrowser) return;
    const modalWrapper = document.querySelector('.modal-lg-request') as HTMLElement;
    if (!modalWrapper) return;
    const width = Math.min(1218, Math.max(640, window.innerWidth - 32));
    modalWrapper.classList.add('expand');
    modalWrapper.style.maxWidth = `${width}px`;
    modalWrapper.style.width = `${width}px`;
  }

  public resetModalWidth(): void {
    if(!this.isBrowser) return;
    const modalWrapper = document.querySelector('.modal-lg-request') as HTMLElement;
    if (modalWrapper) {
      modalWrapper.classList.remove('expand');
      modalWrapper.style.width = '';
      modalWrapper.style.maxWidth = '';
      modalWrapper.style.transition = '';
    }
  }

  public closeStoryBuilder(): void {
    if(!this.isBrowser) return;
    this.isShowModal = false;
    this.isshowTag = false;
    this.isShowmedia = false;
    this.resetModalWidth();
  }

  public onPeopleSelectionChange(event: any): void {
    const items = event || [];
    const ids = items.map(item => (item && item.id != null ? item.id : item));
    this.selectedPeopleIds = ids;
    this.selectedData = ids;
    (this.members || []).forEach((member) => {
      member.checked = ids.indexOf(member.id) > -1;
    });
    if (!ids.length) {
      this.showAllRequestLinks = false;
      this.requestLinksQuery = '';
    }
    this.updateData();
  }

  get selectedRequestLinks(): any[] {
    return (this.members || []).filter((member) => member && member.checked);
  }

  get filteredRequestLinks(): any[] {
    const query = (this.requestLinksQuery || '').trim().toLowerCase();
    const links = this.selectedRequestLinks;
    if (!query) {
      return links;
    }
    return links.filter((member) => {
      const name = String(member.display_name || member.displayName || '').toLowerCase();
      const email = String(member.email || '').toLowerCase();
      return name.indexOf(query) > -1 || email.indexOf(query) > -1;
    });
  }

  get visibleRequestLinks(): any[] {
    const links = this.filteredRequestLinks;
    return this.showAllRequestLinks ? links : links.slice(0, 3);
  }

  public toggleShowAllRequestLinks(): void {
    this.showAllRequestLinks = !this.showAllRequestLinks;
  }

  public removeRequestLink(person: any): void {
    if (!this.isBrowser || !person) return;
    // Keep remaining members in place — do not reload (that clears their urls).
    person.checked = false;
    person.url = null;
    person.linkCopied = false;
    this.selectedData = (this.selectedData || []).filter((id) => id !== person.id);
    this.selectedPeopleIds = [...this.selectedData];
    this.emailSendIngPayload = (this.emailSendIngPayload || []).filter(
      (payload) => payload && payload.author_email !== person.email
    );
    if (this.selectedRequestLinks.length <= 3) {
      this.showAllRequestLinks = false;
    }
    if (!this.selectedRequestLinks.length) {
      this.resetAfterAllRequestLinksRemoved();
    }
  }

  private resetAfterAllRequestLinksRemoved(): void {
    this.isCopyCode = false;
    this.hideSendanCopylinkButton = false;
    this.showAllRequestLinks = false;
    this.requestLinksQuery = '';
    this.emailSendIngPayload = [];
    this.internalUrl = false;
    this.selectedPeopleIds = [];
    this.selectedData = [];
    this.members = [];
    this.loadUserInputData.pagination.page = 1;
    this.loadMembers([]);
  }

  /**
   * Hide Copy Link UI after an edit so Create Link must be clicked again.
   * Keep story_id/url on members — the API update path needs them in old_url
   * to regenerate unique links.
   */
  private invalidateCreatedRequestLinks(): void {
    if (!this.isCopyCode) return;
    (this.members || []).forEach((member) => {
      if (!member) return;
      member.linkCopied = false;
    });
    this.isCopyCode = false;
    this.hideSendanCopylinkButton = false;
    this.showAllRequestLinks = false;
    this.requestLinksQuery = '';
    this.emailSendIngPayload = [];
    this.requestedUsers = [];
    this.requestForm.patchValue(
      { requestedUser: null, bodyCode: null },
      { emitEvent: false }
    );
  }

  public copyRequestLink(person: any, event: any): void {
    if (!this.isBrowser || !person || !person.url) return;
    const target = event && event.currentTarget ? event.currentTarget : event;
    this.copyMessage(person, target);
  }

  public onPeopleSearch(_event: any): void {}

  public onDropdownFocus(): void {
    this.isDropdownFocused = true;
  }

  public onDropdownBlur(): void {
    this.isDropdownFocused = false;
    this.isDropdownTyping = false;
  }

  public onDropdownSearchChange(searchTerm: string): void {
    this.isDropdownTyping = searchTerm && searchTerm.length > 0;
  }

  GenearateLink(){

  }
  openTag(data){
    if(!this.isBrowser) return;
    this.isShowModal= true;
    const Index = this.stepActive.findIndex((step:any) => step.id == data);
    const step = this.stepActive[Index];
    if (step && step.id == 16) {
      this.isShowmedia = true;
      this.isshowTag = false;
    } else {
      this.isshowTag = true;
      this.isShowmedia = false;
    }
    this.panelCloseColor = (step && step.color) ? step.color : '#106e47';
    this.store$.dispatch(new storyBuilderActions.GotoStep(step.id));
    this.store$.dispatch(new storyBuilderActions.SetStepActive(step));
  }
  sendExternalMainEmail(){
    if(!this.showemailSection){
       this.showemailSection = true;
    }
    else{
      let emails = {
        author_emails:this.requestForm.controls.users.value,
        emailTemplate: this.requestForm.controls.emailTemplate.value,
        emailSubject:this.requestForm.controls.emailSubject.value,
        link:this.externalUrlforCopy
      }
      if(!this.is_not_other_email){
        emails['request_sender_name'] = this.requestForm.value.emailSendername;
      }

      if(this.requestForm.value.languageSelected){
        emails['lang_code'] = this.requestForm.value.languageSelected;
      }
      
      this.store$.dispatch(new storyAction.SendEamilInternalExternal(emails));
      this.toastService.success("Sent")
     this.requestForm.controls.firstname.reset();
     this.requestForm.controls.lastname.reset();
     this.requestForm.controls.email.reset();
     this.externalUrlforCopy = '';
     this.emailSendIngPayload = [];
     this.showemailSection = false;
     this.isSingleInternalRequested = false;
     this.hideSendanCopylinkButton = false;
    }

  }

  copyMessage(player, data: any) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = player.url;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    $(data).attr('title', 'Copied');

    player.linkCopied = true;
    setTimeout(() => {
      $(data).attr('title', 'Click to copy');
      player.linkCopied = false;
    }, 1000)
  }

  copyExternalUrl() {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = this.externalUrlforCopy;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.toastService.success("Copied");
    setTimeout(() => {
      this.buttonText = 'Copy'
    }, 1000)
  }
  

  public close() {
    this.onClose.emit();
  }

  shareadthis(){
    this.isDispalyadthis = true;
    setTimeout(()=>{
      if (typeof (<any>window).shareholic !== 'undefined') { (<any>window).shareholic.layers.refresh(); }
      this.shareholic.nativeElement.setAttribute("data-link", this.externalUrlforCopy);
    },1000)
  }
  closeshare(){
    this.isDispalyadthis = false;
  }

  startRecording() {
    if(this.isBrowser){
    // this.store$.dispatch(new mediaRecordAction.CheckRecord(true))
    // recordData.open();
    // this.isShowRecorder = true;
    // this.isCamera = false;
    let data = {
      storyParam :'',
      questionModels:[],
      showPreviousNextButton:false,
      companyID :this.company.id,
      currentCompany: '',
      interViewStyle: true,
      isPreview: true,
      videoduration: 3 * 60,
      inbound_builder: true,
      isCamera:false,
      isCameraOnly:false,
      allowVideoUpload: true,
      themeButtonColor: this.secondary_button_color
    }

    this.isGreetingRecordingOpen = true;
    this.modalService.showModal(RequestVideoRecorderMediaComponent ,data, {class:'modal-lg-video'}).then((data)=>{
      this.isGreetingRecordingOpen = false;

      if(data){
        this.showelipse = true;
        this.onRecordFinish(data.blobcontent);
        const videoUrl = URL.createObjectURL(data.blobcontent);
        this.dataUrl = videoUrl;
        if(data.campaignDetail){
          // this.campaIgnDetail(data.campaignDetail)
        }
      }
    })

    // let initializeOptions = {token: }
    // const onVideoSdkInitialize = (data, error) => { if(data)
    //   const recorder = RecorderWidget.create(data.key, config);

  }
  }
  public onRecordFinish(recorderData: any) {
    if (this.isBrowser) {
      this.uploadGreetingFile(recorderData);
    }
  }

  public triggerGreetingVideoUpload(): void {
    if (!this.isBrowser) return;
    this.greetingVideoInput?.nativeElement?.click();
  }

  public uploadGreetingVideo(event: Event): void {
    if (!this.isBrowser) return;
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('video/')) {
      this.toastService.error('Please select a valid video file.');
      input.value = '';
      return;
    }

    this.showelipse = true;
    this.dataUrl = URL.createObjectURL(file);
    this.uploadGreetingFile(file);
    input.value = '';
  }

  private resetGreetingUploadState(): void {
    this.showelipse = false;
    this.is_video = false;
    this.dataUrl = '';
    this.asset_id = '';
    this.pendingGreetingUploadId = '';
    this.uploaderViewModel.isUploading = false;
    this.uploaderViewModel.progress = 0;
    this.uploaderViewModel.progressCss = '0%';
  }

  private bindGreetingMuxUploader(muxUploader: any): void {
    if (this.greetingMuxUploaderBound || !muxUploader) {
      return;
    }

    this.greetingMuxUploaderBound = true;
    const self = this;

    muxUploader.addEventListener('progress', (e: any) => {
      const percent = Math.trunc(e.detail);
      self.uploaderViewModel.isUploading = true;
      self.uploaderViewModel.progress = percent;
      self.uploaderViewModel.progressCss = `${percent}%`;

      if (percent === 100 && self.pendingGreetingUploadId) {
        self.uploaderViewModel.progress = 100;
        self.uploaderViewModel.progressCss = '100%';
        self.uploaderViewModel.isUploading = false;
        self.makeMuxApiRequest(self.pendingGreetingUploadId);
      }
    });

    muxUploader.addEventListener('success', () => {
      self.uploaderViewModel.progress = 100;
      self.uploaderViewModel.progressCss = '100%';
      self.uploaderViewModel.isUploading = false;
      if (self.pendingGreetingUploadId) {
        self.makeMuxApiRequest(self.pendingGreetingUploadId);
      }
    });

    muxUploader.addEventListener('uploaderror', () => {
      self.resetGreetingUploadState();
      self.toastService.error('Video upload failed. Please try again.');
    });
  }

  private uploadGreetingFile(file: File | Blob): void {
    if (!this.isBrowser) return;
    const muxUploader: any = document.getElementById('my-uploader-gs');
    if (muxUploader) {
      muxUploader.dynamicChunkSize = true;
    }
    if (!muxUploader) return;

    this.bindGreetingMuxUploader(muxUploader);
    this.pendingGreetingUploadId = '';
    this.showelipse = true;
    this.is_video = true;
    this.uploaderViewModel.isUploading = true;
    this.uploaderViewModel.progress = 0;
    this.uploaderViewModel.progressCss = '0%';

    const greetingFile = file instanceof File
      ? file
      : new File([file], 'greeting.mp4', { type: file.type || 'video/mp4' });

    muxUploader.endpoint = async () => {
      const payload = { origin: window.location.origin };
      const uploadUrl = await this.storyHttpService
        .pollApiUntilReady(this.company?.id, payload)
        .toPromise();
      this.pendingGreetingUploadId = uploadUrl.id;
      return uploadUrl.url;
    };

    muxUploader.dispatchEvent(
      new CustomEvent('file-ready', {
        composed: true,
        bubbles: true,
        detail: greetingFile,
      })
    );
  }

    makeMuxApiRequest(id): void {
      if(!this.uploadedId.length){
        this.uploadedId.push(id);
        this.makeAPiRequest(id);
      }
      if(this.uploadedId.length){
        let index = this.uploadedId.findIndex(item => item == id);
        if(index>=0){
          return
        }
        else{
          this.uploadedId.push(id)
          this.makeAPiRequest(id);
        }
      }
  
    }
  
    makeAPiRequest(id, attempt = 0){
      const maxAttempts = 4;
      this.storyHttpService.CheckpollApiUntilReady(id,this.company.id)
      .subscribe(
        (response: any) => {
          this.asset_id = response;
          this.showelipse = false;
          this.pendingGreetingUploadId = '';

          if(this.externalUrlforCopy && !this.showemailSection){
            this.isSingleInternalRequested = false;
          }
          if(this.internalUrl && !this.sendInternalmail){
            this.hideSendanCopylinkButton = false;
          }
        },
        (error) => {
          console.error('Error:', error);
          if (attempt < maxAttempts) {
            setTimeout(() => this.makeAPiRequest(id, attempt + 1), 3000);
            return;
          }
          this.resetGreetingUploadState();
          this.toastService.error(
            'Video processing failed. Please upload your greeting again.'
          );
        }
      );
    }

    watchVideo(){
      this.isDispalyMenu = true;
      this.show_video = true;
      
      setTimeout(()=>{
        this.videoPlayer.nativeElement.src = this.dataUrl;
      },100)
    }

    acceptVideo() {
      this.videoAccepted = true;
      this.isDispalyMenu = false;
      this.show_video = false;
      // Video is now applied and accepted
    }

    rerecordVideo() {
      this.isDispalyMenu = false;
      this.show_video = false;
      
      // Store original video data in case user cancels
      const originalDataUrl = this.dataUrl;
      const originalAssetId = this.asset_id;
      const originalVideoAccepted = this.videoAccepted;
      
      // Open recording modal again
      this.isGreetingRecordingOpen = true;
      this.modalService.showModal(RequestVideoRecorderMediaComponent, {
        storyParam: '',
        questionModels: [],
        showPreviousNextButton: false,
        companyID: this.company.id,
        currentCompany: '',
        interViewStyle: true,
        isPreview: true,
        videoduration: 3 * 60,
        inbound_builder: true,
        isCamera: false,
        isCameraOnly: false,
        allowVideoUpload: true,
        themeButtonColor: this.secondary_button_color
      }, {class: 'modal-lg-video'}).then((data) => {
        this.isGreetingRecordingOpen = false;
        if(data && data.blobcontent){
          // User recorded a new video
          this.showelipse = true;
          this.onRecordFinish(data.blobcontent);
          const videoUrl = URL.createObjectURL(data.blobcontent);
          this.dataUrl = videoUrl;
          this.videoAccepted = false; // Reset accepted state for new video
          if(this.externalUrlforCopy){
            this.isSingleInternalRequested = false;
          }
          if(this.internalUrl){
            this.hideSendanCopylinkButton = false;
          }
        } else {
          // User closed modal without recording - show styled confirmation
          const confirmationData = {
            title: 'Keep Original Video?',
            message: 'You closed the recording without creating a new video. Would you like to keep your original video or remove it?',
            yesButtonText: 'Keep Original',
            cancelButtonText: 'Remove Video'
          };
          
          this.modalService.showModal(ConfirmationModalComponent, confirmationData, {class: 'modal-sm'}).then((keepVideo) => {
            if(keepVideo) {
              // Keep original video
              this.dataUrl = originalDataUrl;
              this.asset_id = originalAssetId;
              this.videoAccepted = originalVideoAccepted;
              this.is_video = true;
            } else {
              // Remove video
              this.dataUrl = '';
              this.is_video = false;
              this.asset_id = '';
              this.videoAccepted = false;
              if(this.externalUrlforCopy){
                this.isSingleInternalRequested = false;
              }
              if(this.internalUrl){
                this.hideSendanCopylinkButton = false;
              }
            }
          });
        }
      });
    }

    removeVideo(){
      this.isDispalyMenu = false;
      this.show_video = false;
      this.dataUrl = ''
      this.is_video = false;
      this.asset_id = ''
      this.videoAccepted = false;
      if(this.externalUrlforCopy){
        this.isSingleInternalRequested = false;
      }
  
      if(this.internalUrl){
        this.hideSendanCopylinkButton = false;
      }
    }

    addMedia(){
      if(!this.isBrowser) return;
    if(this.isBrowser){
      // this.loadGallery();
      this.isShowModal= true;
      this.isShowmedia = true;
      this.isshowTag = false;
      const mediaStep = this.mediaStep;
      // White close icon on Add Media; menu icons override via openTag.
      this.panelCloseColor = '#ffffff';
      this.store$.dispatch(new storyBuilderActions.GotoStep(2));
      // Steps still loading: syncOpenPanelStep() sends it when they arrive.
      if (mediaStep) {
        this.store$.dispatch(new storyBuilderActions.SetStepActive(mediaStep));
      }
      this.widenRequestModal();
    }
  
    }
  
    /** Give the open Tags / Media panel its step once the steps have loaded. */
    private syncOpenPanelStep(): void {
      if (!this.isShowModal || !this.stepActive) {
        return;
      }
      const step = this.isShowmedia
        ? this.mediaStep
        : (this.isshowTag ? this.stepActive[0] : null);
      if (step) {
        this.store$.dispatch(new storyBuilderActions.SetStepActive(step));
      }
    }

    addTag(){
      if(!this.isBrowser) return;
  if(this.isBrowser){
      this.isShowModal= true;
      this.isshowTag = true;
      this.isShowmedia = false;
      const tagStep = this.stepActive ? this.stepActive[0] : null;
      this.panelCloseColor = (tagStep && tagStep.color) ? tagStep.color : '#106e47';
  
      this.store$.dispatch(new storyBuilderActions.GotoStep(2));
      if (tagStep) {
        this.store$.dispatch(new storyBuilderActions.SetStepActive(tagStep));
      }
  
      this.widenRequestModal();
  }
    }



  closetagbox(data){
    if(!this.isBrowser) return;
  }

  backGuestStories(){
    this.showemailSection = false;
    this.showAuthorDropdown = false;
  }
  
  onAuthorToggleChange(_value: boolean) {
    const control =
      this.requestForm.value.userStatus === 'user'
        ? this.requestForm.controls.userselcted
        : this.requestForm.controls.externalUserSelcted;
    control.setValue(null);
  }

  backInternalStories(){
    this.sendInternalmail = false;
    this.internalUrl = true;
  }


  openMailBox(){
    this.sendInternalmail = true;
    this.isShowModal = false;
    this.internalUrl = false;
    this.resetModalWidth();

  }


  langDropdownOpen = false;

  toggleLangDropdown(event: Event) {
    event.stopPropagation();
    this.langDropdownOpen = !this.langDropdownOpen;
  }
  
  selectLanguage(lang: any, event: Event) {
    event.stopPropagation();
  
    // Update form control manually
    this.requestForm.patchValue({
      languageSelected: lang.code
    });
  
    this.langDropdownOpen = false;
  }

  getLanguagesFromStorage(): any[] {
    const data = localStorage.getItem('languages');
    return data ? JSON.parse(data) : [];
  }
}
